import { Icon } from "@/components/Icon";
import { DictMap, DynamicFormItemProps } from "../trade/components/DynamicForm/DynamicForm";
export const inFormItems: DynamicFormItemProps[] = [{
  fieldLabel: '币种',
  fieldName: 'paymentType',
  fieldType: '3',
  extra: <Icon name={'exchange'} size={'0.18rem'} />,
  readOnly: true
}, {
  fieldLabel: '主网',
  fieldName: 'mainNet',
  fieldType: '1',
  readOnly: true
}, {
  fieldLabel: '钱包地址',
  fieldName: 'address',
  fieldType: 'CopyIcon',
  readOnly: true
}, {
  fieldLabel: '转入数量',
  fieldName: 'amount',
  fieldType: '2'
}];
export const outFormItems: DynamicFormItemProps[] = [{
  fieldLabel: '币种',
  fieldName: 'paymentType',
  fieldType: '3',
  extra: <Icon name={'exchange'} size={'0.18rem'} />,
  readOnly: true
}, {
  fieldLabel: '主网',
  fieldName: 'mainNet',
  fieldType: '1',
  readOnly: true
}, {
  fieldLabel: '钱包地址',
  fieldName: 'usdtAddress',
  fieldType: '3',
  extra: <Icon name={'exchange'} size={'0.18rem'} />
}, {
  fieldLabel: '当前可用保证金',
  fieldName: 'current',
  fieldType: '2',
  readOnly: true
}, {
  fieldLabel: '转出数量(USDT)',
  fieldName: 'amount',
  fieldType: '2'
}];
export const dictMap: DictMap = {
  paymentType: [[{
    value: "USDT",
    text: 'USDT'
  }
  // {value: "TRX",text: 'TRX'},
  ]]
};
export const tabs = [{
  key: 'in',
  title: '保证金转入',
  url: '/deposit_transfer/deposit_transfer_in'
}, {
  key: 'out',
  title: '保证金转出',
  url: '/deposit_transfer/deposit_transfer_out'
}];